import React from "react";

import Chat from "../../pages/components/smechat";

import "../../assets/css/chat.css";
import "../../assets/css/chat-theme.css";
import "../../styles/sme-chat.css";

export type SmeChatTabProps = {
  project: unknown;
  clientUserId: number | string | null;
  projectId: number | string | null;
  isTabActive?: boolean;
  /** Chat history prefetched for sidebar badges — avoids a duplicate fetch on first open. */
  prefetchedChatHistory?: unknown[] | null;
};

export function SmeChatTab({
  project,
  clientUserId,
  projectId,
  isTabActive = true,
  prefetchedChatHistory = null,
}: SmeChatTabProps) {
  if (!project || !clientUserId || !projectId) {
    return (
      <p className="sme-chat-panel__empty">Select a project to open the client conversation.</p>
    );
  }

  return (
    <div className="sme-chat-panel client-chat-shell">
      <Chat
        key={`chat-${projectId}-${clientUserId}`}
        project={project}
        clientUserId={clientUserId}
        isTabActive={isTabActive}
        prefetchedChatHistory={prefetchedChatHistory}
      />
    </div>
  );
}

export default SmeChatTab;
